import { marked } from 'marked';
function setupLinkRender() {
    const linkRenderer = new marked.Renderer();
    linkRenderer.link = function (href, title, text) {
        let external = true, newWindow, out;
        // We are using parent bacause we are in a iframe.
        const location = window.location;
        if (location.origin === 'undefined' || location.origin === 'null') {
            location.origin = location.protocol + '//' + location.host;
        }
        if (href.indexOf(location.origin) > -1) {
            external = false;
        }
        if (external === true || title === 'newWindow') {
            newWindow = true;
        }
        out = '<a href="' + href + '"';
        if (newWindow) {
            out += ' rel="noopener noreferrer"';
            out += ' target="_blank"';
        }
        if (title && title !== 'newWindow') {
            out += ' title="' + title + '"';
        }
        out += '>' + text + '</a>';
        return out;
    };
    return linkRenderer;
}
marked.setOptions({
    renderer: setupLinkRender(),
    gfm: true,
    breaks: true,
    mangle: false,
});
export default function markdownToHTML(markdown) {
    return marked(markdown).trim();
}
